import { React, useState, useEffect, useMemo } from 'react'
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import Linechart from './LineChart';
import Chart from 'react-apexcharts';

import "../css/ComponentStyle.css";
import { APIConstants, DashboardConstants, formatDOSDate, IntelliBillConstants, LoginConstants } from '../utilities/Constants';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { useDispatch } from 'react-redux';
import { setAuthToken } from '../redux/actions/userActions';
import { Link } from 'react-router-dom';


const Dashboard = () => {


    const [pdata, setPdata] = useState([]);

    const [product, setProduct] = useState([]);
    const [tdata, setTdata] = useState([]);
    const [rdata, setRdata] = useState([]);
    const [denialRejectedData, setdenialRejectedData] = useState([]);
    const [graphData, setgraphData] = useState([]);
    const [chartdata, setChartdata] = useState([]);

    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(true);
    const [hoveredDate, setHoveredDate] = useState(null);

    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [calendarViewDate, setCalendarViewDate] = useState(new Date());
    const [clearingHouseData, setclearingHouseData] = useState([]);
    const [providerData, setproviderData] = useState([]);
    const [cptData, setcptData] = useState([]);
    const [claimCountData, setClaimCountData] = useState([]);
    const [newToken, setNewToken] = useState(null);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState('DOS');
    const [showPracticeClaims, setShowPracticeClaims] = useState(1);
    const [searchDOS, setSearchDOS] = useState('');
    const [searchProviderDOS, setSearchProviderDOS] = useState('');
    const [searchCptDOS, setSearchCptDOS] = useState('');
    const [searchClearingHouse, setSearchClearingHouse] = useState('');
    const [searchProvider, setSearchProvider] = useState('');
    const [searchCPT, setSearchCPT] = useState('');


    const userData = useSelector((state) => state.user.user);
    console.log('userData:', userData);

    const dispatch = useDispatch();


    const sAuthToken = useSelector((state) => state.user.token);

    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;






    useEffect(() => {
        document.title = 'Billing DashBoard'

        const data = graphData.Data;

        //const categoryDays  = data ?  data.map(item => item.WeekDayName): []

        if (data && data.length >= 7) {
            const last7DaysData = data.slice(data.length - 7); // Get the last 7 records

            const categoryDays = last7DaysData.map(item => item.WeekDayName);



            const seriesData = [
                {
                    name: "Sent",
                    data: last7DaysData.map(item => item.SubmittedClaims),
                },
                {
                    name: "Paid",
                    data: last7DaysData.map(item => item.PaidCPTs),
                },

                {
                    name: "TotalCPTs",
                    data: last7DaysData.map(item => item.TotalCPTs),
                },
                {
                    name: "Denied",
                    data: last7DaysData.map(item => item.DeniedCPTs),
                },
                {
                    name: "Rejected",
                    data: last7DaysData.map(item => item.RejectedClaims),
                },
                {
                    name: "Pending",
                    data: last7DaysData.map(item => item.UnderReviewCPTs),
                },
            ];

            // Update the state with the extracted data


            setProduct(seriesData);
            setOption(prevOption => ({
                ...prevOption,
                xaxis: {
                    ...prevOption.xaxis,
                    categories: categoryDays
                },
            }));
        }
    }, []); // Empty dependency array to run this effect only once on component mount








    const [option, setOption] = useState(
        {

            title: { text: " " },
            xaxis: {
                title: { text: "Weekday " },
                categories: [],
            },
            yaxis: {},
        }
    );





    const handleAllClick = async (startDate, endDate) => {
        setLoading(true);

        try {
            await Promise.all([
                handleGetDashboardCounts(startDate, endDate),
                handleDataClick(startDate, endDate),
                handleClick(startDate, endDate),
                handleGetCHSubmittedClaims(startDate, endDate),
                handleGetProviderClaimsCount(startDate, endDate),
                handleGetCPTClaimsCount(startDate, endDate),
            ]);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {

            setTimeout(() => {
                setLoading(false);


            }, 500);
        }
    };




    useEffect(() => {
        const today = new Date();
        const fifteenDaysAgo = new Date(today);
        fifteenDaysAgo.setDate(today.getDate() - 15);

        setStartDate(fifteenDaysAgo);
        setEndDate(today);

        const formattedStartDate = format(fifteenDaysAgo, 'MM/dd/yyyy');
        const formattedEndDate = format(today, 'MM/dd/yyyy');

        // Call the async data loading function
        handleAllClick(formattedStartDate, formattedEndDate);
    }, []);






    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);

            setIsStartOpen(false);

        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);

            setIsEndOpen(false);

        } else {
            setEndDate(null);
        }
    };



    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };



    const handleCheckboxChange = (e) => {
        setShowPracticeClaims(e.target.checked ? 0 : 1);
    };



    // useEffect(() => {


    // }, [showPracticeClaims]);




    const handleGetDashboardCounts = async (startDate, endDate) => {
        setLoading(true);

        var objInput = {
            iPracticeID: userPracticeID,
            sFromDate: startDate,
            sToDate: endDate,
            sFilterText: userId,
            sFilterType: showPracticeClaims,
            sDateFilterType: selectedDropdownValue

        }

        var sInputJSON = JSON.stringify(objInput);


        const url = `${APIConstants.BASE_URL_BILLING}${DashboardConstants.GetDashboardCounts}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                setTimeout(() => {
                    setLoading(false);
                    setClaimCountData(parsedData.Data);
                    setgraphData(parsedData.Data)

                }, 100);
                console.log("Response of" + DashboardConstants.GetDashboardCounts, parsedData);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    const handleClick = async (startDate, endDate) => {



        //  e.preventDefault();
        try {
            var inputStruct = {

                sFromDate: startDate,
                sToDate: endDate,
                sPracticeID: userPracticeID,
                IsBiller: true,
                sUserID: userId

            };

            var myInput = { sInputJSON: JSON.stringify(inputStruct) };
            console.log("input of " + DashboardConstants.GetDashboardStats, myInput);

            myInput = JSON.stringify(myInput);

            const response = await fetch(APIConstants.BASE_URL + DashboardConstants.GetDashboardStats, {
                method: 'POST',
                headers: {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json'

                },

                body: myInput
            })



            if (response.ok) {
                const data = await response.json();

                const parsedData = JSON.parse(data.d);



                if (parsedData.Status === 'Success') {
                    // Parse the PracticeData and UserData JSON within Data
                    const practiceData = JSON.parse(parsedData.Data.PracticeData);
                    const userData = JSON.parse(parsedData.Data.UserData);

                    // Set the parsed data
                    setPdata({ practiceData, userData });
                    console.log("practiceData of" + DashboardConstants.GetDashboardStats, practiceData)

                } else {
                    setError('API request failed');
                }
            }
            setLoading(false);
        }
        catch (error) {
            setError('API request failed');
            setLoading(false);
        }
    }


    useEffect(() => {


    }, [pdata]);




    const handleDataClick = (startDate, endDate) => {


        var inputStruct = {

            sFromDate: startDate,
            sToDate: endDate,
            sPracticeID: userPracticeID,
            IsBiller: true,
            sUserID: userId,

        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };
        console.log("input of" + DashboardConstants.GetDenRejReasons, myInput);
        myInput = JSON.stringify(myInput);

        fetch(APIConstants.BASE_URL + DashboardConstants.GetDenRejReasons, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then(response => response.json())
            .then(data => {


                const parsedDenialRejData = JSON.parse(data.d);





                if (parsedDenialRejData.Status === 'Success') {

                    const dnData = JSON.parse(parsedDenialRejData.Data.DeniedStats);
                    const rejectedData = JSON.parse(parsedDenialRejData.Data.RejectedStats);

                    // Set the parsed data
                    setdenialRejectedData({ dnData, rejectedData });
                    console.log("Response of" + DashboardConstants.GetDenRejReasons, denialRejectedData)

                } else {
                    setError('API request failed');
                }
                setLoading(false);
            })
            .catch((error) => {
                setError('API request failed');
                setLoading(false);
            });

    }




    const handleGetCHSubmittedClaims = async (startDate, endDate) => {

        setLoading(true);

        var objInput = {
            PracticeID: userPracticeID,
            FromDate: startDate,
            ToDate: endDate,
            FilterText: userId,
            FilterType: showPracticeClaims,
            DateFilterType: selectedDropdownValue

        }

        var sInputJSON = JSON.stringify(objInput);


        const url = `${APIConstants.BASE_URL_BILLING}${DashboardConstants.GetCHSubmittedClaims}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                setTimeout(() => {
                    setLoading(false);
                    setclearingHouseData(parsedData)

                }, 100);


            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    const handleGetProviderClaimsCount = async (startDate, endDate) => {
        setLoading(true);

        var objInput = {
            PracticeID: userPracticeID,
            FromDate: startDate,
            ToDate: endDate,
            FilterText: userId,
            FilterType: showPracticeClaims,
            DateFilterType: selectedDropdownValue

        }

        var sInputJSON = JSON.stringify(objInput);


        const url = `${APIConstants.BASE_URL_BILLING}${DashboardConstants.GetProviderClaimsCount}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                setTimeout(() => {
                    setLoading(false);
                    // setproviderData(parsedData)

                }, 100);


            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    const handleGetCPTClaimsCount = async (startDate, endDate) => {
        setLoading(true);

        var objInput = {
            PracticeID: userPracticeID,
            FromDate: startDate,
            ToDate: endDate,
            FilterText: userId,
            FilterType: showPracticeClaims,
            DateFilterType: selectedDropdownValue

        }

        var sInputJSON = JSON.stringify(objInput);


        const url = `${APIConstants.BASE_URL_BILLING}${DashboardConstants.GetCPTClaimsCount}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                setTimeout(() => {
                    setLoading(false);
                    setcptData(parsedData)

                }, 100);


            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }

    const handleStartDoneClick = () => {
        setIsStartOpen(false);
    };




    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);
            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };





    const CalendarContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'space-between', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
                    Today
                </button>

            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );





    const calculateColumnTotals = (data = [], keys = []) => {
        const totals = {};
        keys.forEach((key) => {
            totals[key] = data.reduce((acc, item) => acc + (parseInt(item[key], 10) || 0), 0);
        });
        return totals;
    };





    const summaryKeys = [
        "SubmittedClaims",
        "ForwardedClaims",
        "PaidCPTs",
        "RejectedClaims",
        "DeniedCPTs",
        "ValidationErrorCPT",
        "SubmissionFailedCPT",
    ];


    const claimCountsTotals = calculateColumnTotals(claimCountData, summaryKeys);
    const clearingHouseTotals = calculateColumnTotals(clearingHouseData, summaryKeys);
    const CPTCountsTotals = calculateColumnTotals(cptData, summaryKeys);
    const ProviderTotals = calculateColumnTotals(providerData, summaryKeys);



    // For ClearingHouse table
    const filteredClearingHouse = clearingHouseData.filter(item => {
        const dosMatch = searchDOS === '' || (item.DOS && item.DOS.toLowerCase().includes(searchDOS.toLowerCase()));
        const clearingHouseMatch = searchClearingHouse === '' || (item.ClearingHouse && item.ClearingHouse.toLowerCase().includes(searchClearingHouse.toLowerCase()));
        return dosMatch && clearingHouseMatch;
    });

    // For CPTData table
    const filteredCPTData = cptData.filter(item => {
        const dosMatch = searchCptDOS === '' || (item.DOS && item.DOS.toLowerCase().includes(searchCptDOS.toLowerCase()));
        const cptMatch = searchCPT === '' || (item.CPTCode && item.CPTCode.toLowerCase().includes(searchCPT.toLowerCase()));
        return dosMatch && cptMatch;
    });

    // For ProviderData table
    const filteredProviderData = providerData.filter(item => {
        const dosMatch = searchProviderDOS === '' || (item.DOS && item.DOS.toLowerCase().includes(searchProviderDOS.toLowerCase()));
        const providerMatch = searchProvider === '' || (item.ProviderName && item.ProviderName.toLowerCase().includes(searchProvider.toLowerCase()));
        return dosMatch && providerMatch;
    });





    const handleLinkClick = (Dos, statusType) => {
        const formattedSDate = formatDOSDate(Dos);

        const url = `/#/MedicalClaimStatus?FilterName=Status&FilterType=1&FilterDateType=DOS&FilterValue=${statusType}&FromDate=${formattedSDate}&ToDate=${formattedSDate}&FilterLabel=`

        window.open(url, '_blank');
    };


    const handleRejLinkClick = (Dos) => {
        const formattedSDate = formatDOSDate(Dos);

        const url = `/#/workableclaims/rejectedclaims?FilterName=Status&FilterType=1&FilterDateType=DOS&FromDate=${formattedSDate}&ToDate=${formattedSDate}`

        window.open(url, '_blank');
    };



    const handleDeniedClick = (Dos) => {
        const formattedSDate = formatDOSDate(Dos);

        const url = `/#/workableclaims/deniedclaims?FilterName=Status&FilterType=1&FilterDateType=DOS&FromDate=${formattedSDate}&ToDate=${formattedSDate}`

        window.open(url, '_blank');
    };


    const handleErrorClick = (Dos) => {
        const formattedSDate = formatDOSDate(Dos);

        const url = `/#/workableclaims/errorclaims?FilterName=Status&FilterType=1&FilterDateType=DOS&FromDate=${formattedSDate}&ToDate=${formattedSDate}`

        window.open(url, '_blank');
    };


    const handleFailedClick = (Dos) => {
        const formattedSDate = formatDOSDate(Dos);

        const url = `/#/workableclaims/submissionclaims?FilterName=Status&FilterType=1&FilterDateType=DOS&FromDate=${formattedSDate}&ToDate=${formattedSDate}`

        window.open(url, '_blank');
    };


    return (
        <>

            <div className='screen' >

                <div className='home-container' >
                    <div className='topnavmenu'>
                        <label className='active-label'>DashBoard</label>
                    </div>

                    <div style={{ display: 'flex', backgroundColor: 'lightgrey', height: '50px', marginTop: '5px' }}>

                        <div style={{ marginTop: '10px', marginLeft: '10px' }}>


                            <select name="select" style={{ height: '25px', border: '1px solid black' }}
                                value={selectedDropdownValue}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setSelectedDropdownValue(selectedValue);

                                }}
                            >

                                <option value="DOS" >DOS</option>
                                <option value="DOA" >To Approve</option>
                                <option value="DOSub" >Submit Date</option>
                            </select>

                        </div>

                        <div className="datepicker-container" style={{ marginLeft: '20px', marginTop: '10px' }}>

                            <label style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>From Date:</label>
                            <DatePicker
                                selected={startDate ? new Date(startDate) : null}
                                onChange={handleStartDateChange}
                                dateFormat="MM/dd/yyyy"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                yearDropdownItemNumber={100}

                                className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                                placeholderText="MM/dd/yyyy"
                                calendarContainer={CalendarStartContainer}

                                open={isStartOpen}
                                onFocus={() => setIsStartOpen(true)}
                                onInputClick={() => setIsStartOpen(true)}
                                onClickOutside={() => setIsStartOpen(false)}
                                renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                    const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                    const selectedMonth = selectedDate.getMonth();
                                    const selectedYear = selectedDate.getFullYear();

                                    return (
                                        <div style={{ zIndex: 9999 }}>
                                            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px', padding: '5px' }}>
                                                {"<"}
                                            </button>
                                            <select
                                                value={selectedMonth}
                                                onChange={({ target: { value } }) => changeMonth(Number(value))}
                                            >
                                                {getMonths(selectedYear)}
                                            </select>
                                            <select
                                                value={selectedYear}
                                                onChange={({ target: { value } }) => changeYear(Number(value))}
                                            >
                                                {Array.from({ length: 100 }, (v, k) => (
                                                    <option key={k} value={new Date().getFullYear() - k}>
                                                        {new Date().getFullYear() - k}
                                                    </option>
                                                ))}
                                            </select>
                                            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px', padding: '5px' }}>
                                                {">"}
                                            </button>

                                        </div>


                                    );
                                }}



                            />
                        </div>

                        <div className="datepicker-container" style={{ marginLeft: '5px', marginTop: '10px' }}>
                            <label style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>To Date:</label>
                            <DatePicker
                                selected={endDate ? new Date(endDate) : null}
                                onChange={handleEndDateChange}
                                dateFormat="MM/dd/yyyy"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                yearDropdownItemNumber={100}
                                className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                                placeholderText="MM/dd/yyyy"
                                popperPlacement="bottom-start"

                                calendarContainer={CalendarContainer}
                                open={isEndOpen}
                                onFocus={() => setIsEndOpen(true)}
                                onInputClick={() => setIsEndOpen(true)}
                                onClickOutside={() => setIsEndOpen(false)}

                                renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                    const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                    const selectedMonth = selectedDate.getMonth();
                                    const selectedYear = selectedDate.getFullYear();

                                    return (
                                        <div>
                                            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                                {"<"}
                                            </button>
                                            <select
                                                value={selectedMonth}
                                                onChange={({ target: { value } }) => changeMonth(Number(value))}
                                            >
                                                {getMonths(selectedYear)}
                                            </select>
                                            <select
                                                value={selectedYear}
                                                onChange={({ target: { value } }) => changeYear(Number(value))}
                                            >
                                                {Array.from({ length: 100 }, (v, k) => (
                                                    <option key={k} value={new Date().getFullYear() - k}>
                                                        {new Date().getFullYear() - k}
                                                    </option>
                                                ))}
                                            </select>
                                            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                                {">"}
                                            </button>



                                        </div>
                                    );
                                }}
                            />
                        </div>



                        <label style={{ display: "flex", alignItems: "center", gap: "5px", marginLeft: '10px', fontSize: '1.2rem', marginTop: '5px' }}>
                            <input

                                type="checkbox"
                                checked={showPracticeClaims == 0}
                                onChange={handleCheckboxChange}
                            />
                            Show Practice Claims
                        </label>

                        <Button variant='warning' className='button mt-2' onClick={() => handleAllClick(startDate, endDate)}>Search</Button>




                    </div>






                    <div className='d-flex mt-2' style={{justifyContent: "space-between"}}>


                        <div className="card mb-4 shadow" style={{ border: '2px solid blue', borderRadius: '10px', width: '840px', height: '600px', overflow: 'auto', marginLeft: '5px' }}>
                            <div className="card-header bg-primary text-white">
                                <h5 className="mb-0">Claim Counts Summary</h5>
                            </div>
                            <div className="card-body p-0">
                                <table className="table table-hover table-striped table-info table-bordered mb-0">
                                    <thead>

                                        <tr className='align-top' >

                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>#</th>
                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>DOS

                                            </th>
                                            <th style={{ backgroundColor: '#c9c9b2' }}>Submitted

                                            </th>

                                            <th style={{ backgroundColor: '#c9c9b2', color: 'black' }}>Forwarded

                                            </th>


                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Paid


                                            </th>
                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Rejected

                                            </th>

                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Denied

                                            </th>


                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Error

                                            </th>

                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Failed

                                            </th>



                                        </tr>


                                    </thead>

                                    <tbody>


                                        {Array.isArray(claimCountData) && claimCountData.length > 0 ? (
                                            claimCountData.map((item, index) => (

                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{formatDOSDate(item.DOS)}</td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, 'sub')}>{item.SubmittedClaims}</Link></td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, '5')}>{item.ForwardedClaims}</Link></td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, '1')}>{item.PaidCPTs}</Link></td>
                                                    <td><Link onClick={() => handleRejLinkClick(item.DOS)}>{item.RejectedClaims}</Link></td>
                                                    <td><Link onClick={() => handleDeniedClick(item.DOS)}>{item.DeniedCPTs}</Link></td>
                                                    <td><Link onClick={() => handleErrorClick(item.DOS)}>{item.ValidationErrorCPT}</Link></td>
                                                    <td><Link onClick={() => handleFailedClick(item.DOS)}>{item.SubmissionFailedCPT}</Link></td>

                                                </tr>

                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: 'center' }}>
                                                    No Records Found
                                                </td>
                                            </tr>
                                        )}


                                    </tbody>

                                    <tfoot style={{ position: 'sticky' }}>
                                        <tr>
                                            <td colSpan="2" style={{ fontWeight: "bold", backgroundColor: "gray" }}>
                                                Total
                                            </td>
                                            {summaryKeys.map((key) => (
                                                <td key={key} style={{ fontWeight: "bold", backgroundColor: "gray" }}>
                                                    <Link style={{ color: 'black' }}>{claimCountsTotals[key] || 0}</Link>
                                                </td>
                                            ))}
                                        </tr>
                                    </tfoot>


                                </table>

                            </div>
                        </div>

                        <div className="card mb-4 shadow" style={{ border: '2px solid blue', borderRadius: '10px', width: '860px', height: '600px', overflow: 'auto'}}>
                            <div className="card-header bg-primary text-white">
                                <h5 className="mb-0">ClearingHouse Claim Summary</h5>
                            </div>
                            <div className="card-body p-0" >
                                <table className="table table-hover table-striped table-info table-bordered mb-0 fixed-header">
                                    <thead>

                                        <tr className='align-top' >

                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>#</th>
                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>DOS
                                                <input
                                                    type="text"
                                                    style={{ width: '100px', borderRadius: '5px' }}
                                                    placeholder="Search"
                                                    value={searchDOS}
                                                    onChange={(e) => setSearchDOS(e.target.value)}
                                                />
                                            </th>
                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>Clearing House
                                                <input
                                                    type="text"
                                                    style={{ width: '100px', borderRadius: '5px' }}
                                                    placeholder="Search"
                                                    value={searchClearingHouse}
                                                    onChange={(e) => setSearchClearingHouse(e.target.value)}
                                                />
                                            </th>

                                            <th style={{ backgroundColor: '#c9c9b2' }}>Submitted

                                            </th>

                                            <th style={{ backgroundColor: '#c9c9b2', color: 'black' }}>Forwarded

                                            </th>


                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Paid


                                            </th>
                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Rejected

                                            </th>

                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Denied

                                            </th>


                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Error

                                            </th>

                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Failed

                                            </th>



                                        </tr>


                                    </thead>

                                    <tbody>


                                        {Array.isArray(filteredClearingHouse) && filteredClearingHouse.length > 0 ? (
                                            filteredClearingHouse.map((item, index) => (

                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{formatDOSDate(item.DOS)}</td>
                                                    <td>{item.ClearingHouse}</td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, 'sub')}>{item.SubmittedClaims}</Link></td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, '5')}>{item.ForwardedClaims}</Link></td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, '1')}>{item.PaidCPTs}</Link></td>
                                                    <td><Link onClick={() => handleRejLinkClick(item.DOS)}>{item.RejectedClaims}</Link></td>
                                                    <td><Link onClick={() => handleDeniedClick(item.DOS)}>{item.DeniedCPTs}</Link></td>
                                                    <td><Link onClick={() => handleErrorClick(item.DOS)}>{item.ValidationErrorCPT}</Link></td>
                                                    <td><Link onClick={() => handleFailedClick(item.DOS)}>{item.SubmissionFailedCPT}</Link></td>

                                                </tr>

                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: 'center' }}>
                                                    No Records Found
                                                </td>
                                            </tr>
                                        )}


                                    </tbody>
                                    <tfoot className='fixed-footer'>
                                        <tr>
                                            <td colSpan="3" style={{ fontWeight: "bold", backgroundColor: "gray" }}>
                                                Total
                                            </td>
                                            {summaryKeys.map((key) => (
                                                <td key={key} style={{ fontWeight: "bold", backgroundColor: "gray" }}>
                                                    <Link style={{ color: 'black' }}>{clearingHouseTotals[key] || 0}</Link>
                                                </td>
                                            ))}
                                        </tr>
                                    </tfoot>


                                </table>
                            </div>
                        </div>



                    </div>



                    <div className='d-flex mt-2' style={{justifyContent: "space-between"}}>


                        <div className="card mb-4 shadow" style={{ border: '2px solid blue', borderRadius: '10px', width: '840px', height: '600px', overflow: 'auto', marginLeft: '5px' }}>
                            <div className="card-header bg-primary text-white">
                                <h5 className="mb-0">CPT Claim Summary</h5>
                            </div>
                            <div className="card-body p-0">
                                <table className="table table-hover table-striped table-info table-bordered mb-0 fixed-header">
                                    <thead>
                                        <tr className='align-top'>
                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>#</th>
                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>DOS
                                                <input
                                                    type="text"
                                                    style={{ width: '100px', borderRadius: '5px' }}
                                                    placeholder="Search"
                                                    value={searchCptDOS}
                                                    onChange={(e) => setSearchCptDOS(e.target.value)}
                                                />
                                            </th>
                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>CPT
                                                <input
                                                    type="text"
                                                    style={{ width: '100px', borderRadius: '5px' }}
                                                    placeholder="Search"
                                                    value={searchCPT}
                                                    onChange={(e) => setSearchCPT(e.target.value)}
                                                />
                                            </th>
                                            <th style={{ backgroundColor: '#c9c9b2' }}>Submitted</th>
                                            <th style={{ backgroundColor: '#c9c9b2' }}>Forwarded</th>
                                            <th style={{ backgroundColor: '#e9e993' }}>Paid</th>
                                            <th style={{ backgroundColor: '#e9e993' }}>Rejected</th>
                                            <th style={{ backgroundColor: '#e9e993' }}>Denied</th>
                                            <th style={{ backgroundColor: '#e9e993' }}>Error</th>
                                            <th style={{ backgroundColor: '#e9e993' }}>Failed</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(filteredCPTData) && filteredCPTData.length > 0 ? (
                                            filteredCPTData.map((item, index) => (
                                                <tr key={index} className="text-center">
                                                    <td>{index + 1}</td>
                                                    <td>{formatDOSDate(item.DOS)}</td>
                                                    <td>{item.CPTCode}</td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, 'sub')}>{item.SubmittedClaims}</Link></td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, '5')}>{item.ForwardedClaims}</Link></td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, '1')}>{item.PaidCPTs}</Link></td>
                                                    <td><Link onClick={() => handleRejLinkClick(item.DOS)}>{item.RejectedClaims}</Link></td>
                                                    <td><Link onClick={() => handleDeniedClick(item.DOS)}>{item.DeniedCPTs}</Link></td>
                                                    <td><Link onClick={() => handleErrorClick(item.DOS)}>{item.ValidationErrorCPT}</Link></td>
                                                    <td><Link onClick={() => handleFailedClick(item.DOS)}>{item.SubmissionFailedCPT}</Link></td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={10} className="text-center">No Records Found</td>
                                            </tr>
                                        )}
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <td colSpan="3" style={{ fontWeight: "bold", backgroundColor: "gray" }}>
                                                Total
                                            </td>
                                            {summaryKeys.map((key) => (
                                                <td key={key} style={{ fontWeight: "bold", backgroundColor: "gray" }}>
                                                    <Link style={{ color: 'black' }}>{CPTCountsTotals[key] || 0}</Link>
                                                </td>
                                            ))}
                                        </tr>
                                    </tfoot>

                                </table>
                            </div>
                        </div>


                        <div className="card mb-4 shadow" style={{ border: '2px solid blue', borderRadius: '10px', width: '860px', height: '600px', overflow: 'auto'}}>
                            <div className="card-header bg-primary text-white">
                                <h5 className="mb-0">Provider Claim Summary</h5>
                            </div>
                            <div className="card-body p-0">
                                <table className="table table-hover table-striped table-info table-bordered mb-0 fixed-header">
                                    <thead>

                                        <tr className='align-top' >

                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>#</th>
                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>DOS
                                                <input
                                                    type="text"
                                                    style={{ width: '100px', borderRadius: '5px' }}
                                                    placeholder="Search"
                                                    value={searchProviderDOS}
                                                    onChange={(e) => setSearchProviderDOS(e.target.value)}
                                                />
                                            </th>
                                            <th style={{ backgroundColor: '#0173b7', color: 'white' }}>Provider Name
                                                <input
                                                    type="text"
                                                    style={{ width: '100px', borderRadius: '5px' }}
                                                    placeholder="Search"
                                                    value={searchProvider}
                                                    onChange={(e) => setSearchProvider(e.target.value)}
                                                />
                                            </th>

                                            <th style={{ backgroundColor: '#c9c9b2' }}>Submitted

                                            </th>

                                            <th style={{ backgroundColor: '#c9c9b2', color: 'black' }}>Forwarded

                                            </th>


                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Paid


                                            </th>
                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Rejected

                                            </th>

                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Denied

                                            </th>


                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Error

                                            </th>

                                            <th style={{ backgroundColor: '#e9e993', color: 'black' }}>Failed

                                            </th>



                                        </tr>


                                    </thead>

                                    <tbody>


                                        {Array.isArray(filteredProviderData) && filteredProviderData.length > 0 ? (
                                            filteredProviderData.map((item, index) => (

                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{formatDOSDate(item.DOS)}</td>
                                                    <td>{item.ProviderName}</td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, 'sub')}>{item.SubmittedClaims}</Link></td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, '5')}>{item.ForwardedClaims}</Link></td>
                                                    <td><Link onClick={() => handleLinkClick(item.DOS, '1')}>{item.PaidCPTs}</Link></td>
                                                    <td><Link onClick={() => handleRejLinkClick(item.DOS)}>{item.RejectedClaims}</Link></td>
                                                    <td><Link onClick={() => handleDeniedClick(item.DOS)}>{item.DeniedCPTs}</Link></td>
                                                    <td><Link onClick={() => handleErrorClick(item.DOS)}>{item.ValidationErrorCPT}</Link></td>
                                                    <td><Link onClick={() => handleFailedClick(item.DOS)}>{item.SubmissionFailedCPT}</Link></td>

                                                </tr>

                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: 'center' }}>
                                                    No Records Found
                                                </td>
                                            </tr>
                                        )}


                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <td colSpan="3" style={{ fontWeight: "bold", backgroundColor: "gray" }}>
                                                Total
                                            </td>
                                            {summaryKeys.map((key) => (
                                                <td key={key} style={{ fontWeight: "bold", backgroundColor: "gray" }}>
                                                    <Link style={{ color: 'black' }}>{ProviderTotals[key] || 0}</Link>
                                                </td>
                                            ))}
                                        </tr>
                                    </tfoot>


                                </table>

                            </div>
                        </div>





                    </div>

                    {loading && (
                        <div className="overlay">
                            <div className="spinner-container">
                                <div className="spinner-grow text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-warning" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}





                    <div className='d-flex'>

                        <div className='chart-container1 mt-5'>
                            <div>

                                <div className='graph-style container-fluid mt-5 mb-3 ' style={{ marginLeft: '20px' }}>
                                    {graphData ? (
                                        <Chart type='line'
                                            width={540}
                                            height={280}
                                            series={product}
                                            options={option}
                                        >
                                        </Chart>

                                    ) : (

                                        <>
                                            <Chart type='line'
                                                width={540}
                                                height={280}
                                                series={product}
                                                options={option}
                                            >
                                            </Chart>

                                        </>
                                    )}

                                </div>


                            </div>
                        </div>






                        <div className='card-container'>



                            <Card style={{ width: '30rem', backgroundColor: '#488bbb', height: '320px', marginTop: '0px', marginLeft: '50px' }}>

                                <Card.Body>
                                    <Card.Title style={{ color: 'white', textAlign: 'center' }}>Top Rejections</Card.Title>
                                    {denialRejectedData.rejectedData && denialRejectedData.rejectedData.length > 0 ? (

                                        <Table striped bordered hover className='table-style'>
                                            <thead>
                                                <tr>

                                                    <th>Reasons</th>
                                                    <th>Claims</th>

                                                </tr>

                                            </thead>

                                            <tbody >
                                                <tr>
                                                    <td className='res-style'>{denialRejectedData.rejectedData[0]?.Reason}</td>
                                                    <td>{denialRejectedData.rejectedData[0]?.Count}</td>
                                                </tr>

                                                <tr>
                                                    <td className='res-style'>{denialRejectedData.rejectedData[1]?.Reason}</td>
                                                    <td>{denialRejectedData.rejectedData[1]?.Count}</td>
                                                </tr>

                                                <tr>
                                                    <td className='res-style'>{denialRejectedData.rejectedData[2]?.Reason}</td>
                                                    <td>{denialRejectedData.rejectedData[2]?.Count}</td>
                                                </tr>

                                                <tr>
                                                    <td className='res-style'>{denialRejectedData.rejectedData[3]?.Reason}</td>
                                                    <td>{denialRejectedData.rejectedData[3]?.Count}</td>
                                                </tr>


                                            </tbody>
                                        </Table>



                                    ) : (
                                        <>
                                            <Table striped bordered hover className='table-style' >
                                                <thead>
                                                    <tr>

                                                        <th>Reasons</th>
                                                        <th>Claims</th>

                                                    </tr>

                                                </thead>



                                                <tbody>
                                                    <tr>
                                                        <td>No Data</td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td>No Data</td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td>No Data</td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td>No Data</td>
                                                        <td></td>
                                                    </tr>


                                                </tbody>

                                            </Table>

                                        </>
                                    )}

                                </Card.Body>
                            </Card>


                            {loading && (
                                <div className="overlay">
                                    <div className="spinner-container">
                                        <div className="spinner-grow text-danger" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <div className="spinner-grow text-warning" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <div className="spinner-grow text-info" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </div>
                            )}





                            <Card style={{ width: '30rem', backgroundColor: '#488bbb', marginLeft: '40px', height: '320px', marginTop: '0px', marginLeft: '30px' }}>

                                <Card.Body>
                                    <Card.Title style={{ color: 'white', textAlign: 'center' }}>Top Denials</Card.Title>

                                    {denialRejectedData.dnData && denialRejectedData.dnData.length > 0 ? (
                                        <Table striped bordered hover className='table-style' >
                                            <thead>
                                                <tr>

                                                    <th>Reasons</th>
                                                    <th>Claims</th>

                                                </tr>

                                            </thead>



                                            <tbody>
                                                <tr>
                                                    <td className='res-style'>{denialRejectedData.dnData[0]?.Reason}</td>
                                                    <td>{denialRejectedData.dnData[0]?.Count}</td>
                                                </tr>

                                                <tr>
                                                    <td className='res-style'>{denialRejectedData.dnData[1]?.Reason}</td>
                                                    <td>{denialRejectedData.dnData[1]?.Count}</td>
                                                </tr>

                                                <tr>
                                                    <td className='res-style'>{denialRejectedData.dnData[2]?.Reason}</td>
                                                    <td>{denialRejectedData.dnData[2]?.Count}</td>
                                                </tr>

                                                <tr>
                                                    <td className='res-style'>{denialRejectedData.dnData[3]?.Reason}</td>
                                                    <td>{denialRejectedData.dnData[3]?.Count}</td>
                                                </tr>


                                            </tbody>

                                        </Table>
                                    ) : (
                                        <>
                                            <Table striped bordered hover className='table-style' >
                                                <thead>
                                                    <tr>

                                                        <th>Reasons</th>
                                                        <th>Claims</th>

                                                    </tr>

                                                </thead>



                                                <tbody>
                                                    <tr>
                                                        <td>No Data</td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td>No Data</td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td>No Data</td>
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td>No Data</td>
                                                        <td></td>
                                                    </tr>


                                                </tbody>

                                            </Table>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>


                        </div>
                    </div>

                </div >


            </div >
        </>
    )
}

export default Dashboard
